<template>
  <v-app>
    <div class="page">
      <Header />
      <!-- If they are already registered then show them their expiration date -->
      <div id="homeImgContainer" v-if="registeredAlready == true">
        <div class="centered-home">
          <!-- <h2 class="home1">PLAN YOUR TRIP AHEAD!</h2> -->
          <img
            src="../assets/images/registeredpass.svg"
            alt=""
            style="margin-bottom: 20px"
            v-if="expired == false"
            id="checkmark"
          />
          <img
            src="../assets/images/passExpired.svg"
            alt=""
            style="margin-bottom: 20px"
            v-else
          />
          <h3 class="home2" v-if="expired == false">
            Your pass has already<br />
            been registered.
          </h3>
          <h3 class="home2" v-else>Your pass is expired.</h3>
          <div class="passExpires" v-if="expired == false">Pass Expires:</div>
          <div class="passExpires" v-else>Pass Expired:</div>
          <div class="passDate">
            {{ expirationDate }}
          </div>
        </div>
        <!-- <div class="white-back">
          <div id="outline-cont">
            <h5>This pass was last seen at:</h5>
            <div class="divider"></div>
            <div v-for="park in history" :key="park.park">
              <div class="history-flex">
                <div class="park-flex">
                  <img
                    :src="require(`@/assets/ShowIcons/${park.park}.svg`)"
                    alt=""
                    style="padding-right: 15px"
                  />
                  <h6>{{ park.name }}</h6>
                </div>
                <h6>{{ park.date }}</h6>
              </div>

              <div class="divider"></div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- If they don't have a barcode then we let them link it to their registration -->
      <div v-else>
        <!-- This is what the section that asks for their order number and license plate -->
        <div class="main-container" v-if="finished == false">
          <div class="content">
            <h1>2025 Pass Registration</h1>
            <p>This pass registration is for passes purchased online.</p>
            <p>
              If you purchased your pass in person, go
              <span class="underline" @click="goback()">back</span>
            </p>
          </div>
          <div id="form-div">
            <div id="form">
              <h2>Order Number</h2>
              <v-text-field
                v-model="orderNum"
                label="* Order Number"
                color="#727A35"
              ></v-text-field>
              <h2>License Plate</h2>
              <v-text-field
                v-model="license"
                label="* License Plate"
                color="#727A35"
              ></v-text-field>
              <p>
                Check your email for an order number from
                parksupport@parkspassutah.com
              </p>
              <div id="button-div">
                <button @click="register()">Register Now</button>
              </div>
            </div>
          </div>
        </div>
        <!-- This is what they see after a successfull barcode linking -->
        <div id="finished" v-else class="steps-full-flex">
          <div class="steps-container">
            <div class="steps-wrap">
              <div>
                <div class="steps-title">Next Steps:</div>
                <div>
                  <ol>
                    <li>Download the Utah State Parks App</li>
                    <ol type="a">
                      <li>Click on ADD PASS.</li>
                      <li>
                        Enter your information including order number
                        {{ orderNum }}
                      </li>
                    </ol>
                  </ol>
                </div>
                <div>
                  <div class="steps-title">Download the App</div>
                  <div class="d-flex">
                    <div class="next-btn mr-3" @click="goToIOS">IOS</div>
                    <div class="next-btn" @click="goToAndroid">ANDROID</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="steps-wrap">
              <div>
                <div class="steps-title">Order Details</div>
                <div>
                  <div class="steps-subtitle">Order number</div>
                  <div>{{ orderNum }}</div>
                </div>
                <div>
                  <div class="steps-subtitle">Annual pass card number</div>
                  <div>{{ barcode }}</div>
                </div>
                <div>
                  <div class="steps-subtitle">License Plate</div>
                  <div>{{ license }}</div>
                </div>
              </div>
            </div>
            <div class="help">
              Need Help?
              <a
                href="https://parkspass.zendesk.com/hc/en-us"
                class="contact-us"
                >Contact Us</a
              >
            </div>
          </div>
          <div class="order-num-container" ref="OrderNumberScroll">
            <div class="order-num-wrap">
              <div class="pass-now-registered">
                Your pass is now registered!
              </div>
              <div class="order-num">
                <div class="order-num-title">Order Number:</div>
                <div
                  class="mt-1 d-flex"
                  @click="copyToClipboard"
                  style="align-items: center"
                >
                  <div ref="contentToCopy" class="order-num-text">
                    {{ orderNum }}
                  </div>

                  <div class="copy-button ml-2" v-if="copied == false">
                    <div class="copy-text mr-1">Copy</div>
                    <v-icon color="white" class="copy-icon"
                      >mdi-content-copy</v-icon
                    >
                  </div>
                  <h4 v-else id="copied">Copied!</h4>
                </div>
              </div>
            </div>
            <!-- <div class="another-pass mt-6" @click="registerAnother">
            Register Another Pass
          </div> -->
          </div>
        </div>
      </div>

      <div id="sticky">
        <Footer />
      </div>
      <!-- They need to have both fields filled out -->
      <v-dialog v-model="emptyFields" class="online-dialog">
        <v-card class="info-card">
          <img src="../assets/icons/attention-red.svg" alt="" />
          <p class="dia-head">
            Please fill out both the Order Number and License Plate fields.
          </p>
        </v-card>
      </v-dialog>
      <!-- If we do not have a entry in the table with the order number and license plate they entered -->
      <v-dialog v-model="noRecord" class="online-dialog">
        <v-card class="info-card">
          <img src="../assets/icons/attention-red.svg" alt="" />
          <div>
            <p class="dia-head">
              There was not a record found for the Order Number:
              {{ orderNum }} and License Plate: {{ license }}
            </p>
            <p class="dia-head" style="margin-top: 10px">
              Please check your information and try again. If the issue
              persists, please contact us at parksupport@parkspassutah.com
            </p>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import $ from "jquery"; // Ensure jQuery is imported

export default {
  name: "RegisterOnline",
  components: {
    // Footer,
    Header,
    Footer,
  },
  data() {
    return {
      barcode: this.$route.params.id || "",
      finished: false,
      copied: false,
      orderNum: "",
      license: "",
      emptyFields: false, // For dialog to show if fields are empty
      noRecord: false, // For dialog to show if no record is found
      registeredAlready: false, // To check if the pass is already registered
      expired: false, // To check if the pass is expired
    };
  },
  created() {
    // This is where you can fetch any initial data if needed
    this.CheckIfRegistered(this.barcode);
  },
  methods: {
    CheckIfRegistered(barcode) {
      // check if its already registered
      var settings = {
        url: `https://trailwaze.info/parkspass/api/getPassExpirationDate.php?barcode=${barcode}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
      };
      var _this = this;
      $.ajax(settings).done(function (response) {
        console.log(response);
        if (response.response == "NO TICKETS FOUND") {
          console.log("no tickets found");
          // show the registration process
          _this.registeredAlready = false;
        }
        if (response.response == "SUCCESS") {
          // show expiration date
          _this.registeredAlready = true;
          _this.expirationDate = response.tickets[0].date_expires;
          _this.formatDate(_this.expirationDate);

          if (new Date() > new Date(_this.expirationDate)) {
            console.log("pass is expired");
            // handle pass expiration logic here
            this.expired = true;
          }
        }
      });
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);
      const options = { year: "numeric", month: "short", day: "numeric" };
      this.expirationDate = date.toLocaleDateString("en-US", options);
    },
    goback() {
      this.$router.push(`/activate/${this.barcode}`);
    },
    async copyToClipboard() {
      console.log("Hellow");
      try {
        // Use the ref to access the content and then copy it using the Clipboard API
        const textToCopy = this.$refs.contentToCopy.innerText;
        await navigator.clipboard.writeText(textToCopy);
        // Optional: Alert or indicate to the user that the text has been copied
        // alert("Text copied to clipboard!");
        this.copied = true;
        console.log("Text copied to clipboard!");
        console.log("copied", this.copied);
        // wait five seconds and turn copied back to false
        setTimeout(() => {
          this.copied = false;
        }, 5000);
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    },
    goToAndroid() {
      window.location.href =
        "http://play.google.com/store/apps/details?id=edu.utahtech.parkspass.utahstateparks";
    },
    goToIOS() {
      window.location.href =
        "https://apps.apple.com/us/app/utah-state-parks/id1638662132";
    },
    register() {
      // check if order number and license plate are filled out
      if (this.orderNum == "" || this.license == "") {
        //alert("Please fill out all fields.");
        this.emptyFields = true;
        return;
      } else {
        var settings = {
          url: `https://trailwaze.info/parkspass/api/addMAnnualBarcode.php?order_number=${this.orderNum}&barcode=${this.barcode}&lp1=${this.license}`,
          method: "GET",
          timeout: 0,
          dataType: "json",
          headers: {
            PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
          },
        };
        var _this = this;
        $.ajax(settings).done(function (response) {
          console.log(response);
          if (response.result == "error") {
            // show error message
            // alert(
            //   "Could not find a record that matched that order number and license plate. Please check your information and try again."
            // );
            _this.noRecord = true;
          } else {
            // go to the finished page
            _this.finished = true;
          }
        });
      }
    },
    // registerAnother(){
    //   localStorage.clear();
    //   this.$router.push("/activate");
    // }
  },
};
</script>

<style scoped>
/* Your component's styles go here */
.page {
  height: 100vh;
}
#sticky {
  position: relative;
  bottom: 0px;
  width: 100%;
}
.main-container {
  margin: 50px 9rem;
}
h1 {
  color: #494e53;
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}
p {
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  letter-spacing: 0.4px;
  margin-bottom: 0px !important;
}
.underline {
  color: #727a35;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.4px;
}
#form-div {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
#form {
  border-radius: 4px;
  border: 1px solid #9c9c9c;
  background: #f5f5f5;
  padding: 28px 38px;
  width: 400px;
}
h2 {
  color: #494e53;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
}
#form > p {
  color: #000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
#button-div {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
#button-div > button {
  border-radius: 26px;
  background: #727a35;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  letter-spacing: 0.4px;
  padding: 10px 20px;
}
.order-num-container {
  width: 35%;
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  padding: 32px;
}
.order-num-wrap {
  border-radius: 4px;
  border: 1px solid #8f8f8f;
  padding: 16px;
}
.pass-now-registered {
  color: #494e53;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 130% */
}
.order-num {
  color: #494e53;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 75% */
}
.order-num-title {
  color: #494e53;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; /* 225% */
}
.order-num-text {
  color: #494e53;
  font-family: Roboto;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 100% */
}
.copy-button {
  /* width: 98px; */
  padding: 16px 16px 16px 16px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 23px;
  background: #96a145;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.copy-text {
  color: white;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  letter-spacing: 0.4px;
}

.copy-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
#copied {
  color: #96a145;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  letter-spacing: 0.4px;
  margin-left: 10px;
}
.another-pass {
  color: #96a145;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  letter-spacing: 0.4px;
  cursor: pointer;
  border-radius: 23px;
  border: 2px solid #96a145;
  width: 197px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.steps-full-flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}
.steps-container {
  width: 65%;
  /* height: 100vh; */
  margin-left: 32px;
  margin-right: 32px;
  padding: 32px 32px 32px 128px;
}
.steps-wrap {
  border-radius: 4px;
  border: 1px solid #8f8f8f;
  padding: 16px;
  margin-bottom: 32px;
}
.steps-wrap {
  color: #494e53;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
}
.steps-title {
  color: #494e53;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px; /* 220% */
}
.next-btn {
  width: 94px;
  height: 40px;
  /* flex-shrink: 0; */
  border-radius: 54px;
  background: #96a145;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.steps-subtitle {
  color: #494e53;

  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */
}
.help {
  display: flex;
  justify-content: center;
  color: #494e53;

  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
}
.contact-us {
  color: #96a145;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  text-decoration-line: underline;
  margin-left: 5px;
}
.online-dialog {
  width: 65%;
  padding: 20px;
}
.info-card {
  border-radius: 16px;
  border: 1px solid #cdcdcd;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25),
    0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 40px 40px;
  display: flex;
  align-items: flex-start;
}
.dia-head {
  color: #ec8183;
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-left: 10px;
}
#homeImgContainer {
  /* Full height */
  height: calc(100vh - 160px);
  background-image: url("../assets/images/register-home-large.png");
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
}
.centered-home {
  position: relative;
  margin: 0 auto;
  text-align: center;
  max-width: 700px;
  font-family: "boldRoboto";
  z-index: 1;
  padding-top: 200px;
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  align-items: center;
}
.home3 {
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
  /* line-height: 30px;  */
}
.home2 {
  color: #ffffff;
  font-size: 64px;
  font-family: "boldRoboto";
  margin: 0px;
  line-height: 72px;
  /* padding-top: 24px; */
}
.purchase-pass {
  color: #fff;

  text-align: center;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 75% */
  margin-top: 20px;
}
.twelve-months {
  color: var(--material-theme-sys-light-on-secondary, #fff);
  text-align: center;

  /* material-theme/body/large */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  margin-top: 20px;
  margin-bottom: 20px;
}
#checkmark {
  margin-top: 25px;
}
.passExpires {
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  margin-top: 30px;
}
.passDate {
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 10px;
}
@media only screen and (max-width: 850px) {
  .order-num-container {
    width: 100%;
    height: auto;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
  }
  .steps-full-flex {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  .steps-container {
    width: 100%;
    height: auto;
    margin-left: 0px;
    margin-right: 0px;
    padding: 32px 32px 32px 32px;
  }
  #homeImgContainer {
    background-image: url("../assets/images/register-home-small.png");
    height: 100vh;
    overflow-y: hidden !important;
  }
  .centered-home {
    margin-top: 0px;
    padding-top: 20px;
  }
  .home1,
  .home3 {
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px; /* 125% */
    margin-bottom: 10px;
  }
  .home2 {
    color: var(--material-theme-sys-light-on-secondary, #fff);
    text-align: center;
    /* material-theme/display/small */
    font-family: Roboto;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 44px; /* 122.222% */
  }
  .purchase-pass {
    color: var(--material-theme-sys-light-on-secondary, #fff);
    text-align: center;

    /* material-theme/title/medium */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */
  }
  .twelve-months {
    color: var(--material-theme-sys-light-on-secondary, #fff);
    text-align: center;

    /* material-theme/body/large */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
  }
  #homeImgContainer {
    height: calc(100vh - 200px);
  }
}
@media only screen and (max-width: 450px) {
  .main-container {
    margin: 50px 2rem;
  }
  .purchase-pass {
    color: var(--material-theme-sys-light-on-secondary, #fff);
    text-align: center;

    /* material-theme/title/medium */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */
  }
  .twelve-months {
    color: var(--material-theme-sys-light-on-secondary, #fff);
    text-align: center;

    /* material-theme/body/large */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
  }
  .info-card {
    padding: 20px 20px;
  }
  .dia-head {
    font-size: 16px;
  }
}
</style>
